angular.module('Itao.IndicatorMap').directive('featureTable', function (d3, mapConfig) {
  'use strict';

  var identity = d3.hyperion.accessor();
  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;
  var numberFormat = germanNumberFormat(',.2f');

  var featureTable = function () {
    var indicators = [],
      selectedDistrictKeys = [];

    var table = function (selection) {
      selection.each(function (data) {
        var heads = indicators.reduce(function (prev, current) {
          return prev.concat(current.name);
        }, ['Schlüssel', 'Gebiet']);

        var keys = indicators.reduce(function (prev, current) {
          return prev.concat(current.uid);
        }, ['key', 'name']);

        var container = d3.select(this).data([data]);

        var thead = container.select('thead');
        var headings = thead.selectAll('tr').data([heads]);

        headings.enter()
          .append('tr');

        var th = headings.selectAll('th')
          .data(heads);

        th.enter()
          .append('th')
          .attr('class', function (d, i) {
            if (i > 1) {
              return 'align-right';
            }
            return '';
          })
          .append('span');

        th.exit().remove();

        th.select('span')
          .html(identity);

        if (angular.isObject(data)) {
          var bodyData = [['<b>Durchschnitt</b>', ''].concat(indicators.map(function(indicator){
            return data.avg.hasOwnProperty(indicator.uid) && data.avg[indicator.uid] != null ? data.avg[indicator.uid] : '-';
          }))];

          for(var districtUid in data.districts) {
            bodyData.push(keys.map(function(key){
              if(key === 'key') {
                return data.districts[districtUid][key];
              } else if(key === 'name') {
                if(data.districts[districtUid].url) {
                  return '<a class="report-link" title="Gebiets-Bericht anzeigen (neues Fenster)" href="' + data.districts[districtUid].url + '" target="_blank">' + data.districts[districtUid].name + '</a>';
                } else {
                  return data.districts[districtUid].name;
                }
              } else {
                var value = data[districtUid][key];
                if(value == null) {
                  value = '-';
                }
                return value;
              }
            }));
          }

          var tbody = container.select('tbody');
          var rows = tbody.selectAll('tr').data(bodyData, function (d, i) {
            return d[0] !== undefined ? d[0] : i;
          });

          rows.enter()
            .append('tr');

          rows.attr('class', function(d) {
            return selectedDistrictKeys.indexOf(d[0]) === -1 ? '' : 'selected';
          });

          rows.exit().remove();

          var elements = rows.selectAll('td')
            .data(identity);

          elements.enter()
            .append('td')
            .attr('class', function (d, i) {
              if (i > 1) {
                return 'align-right';
              }
              return '';
            });

          elements.exit().remove();

          elements
            .html(function (d, i) {
              var unitText = '';
              if (i > 1 && d !== '-') {
                unitText = indicators[i - 2].unit;
              }

              if(unitText) {
                d = numberFormat(d);
              }
              return d + unitText;
            });
        }
      });
    };

    /**
     * getter/setter for indicators
     * @param {Array} [newIndicators] set of new indicators
     * @returns {*}
     */
    table.indicators = function (newIndicators) {
      if (!arguments.length) {
        return indicators;
      } else {
        indicators = newIndicators;
        return table;
      }
    };

    /**
     * getter/setter for selectedDistrictKeys
     * @param {Array} [newSelectedDistrictKeys] set of new selectedDistrictKeys
     * @returns {*}
     */
    table.selectedDistrictKeys = function (newSelectedDistrictKeys) {
      if (!arguments.length) {
        return selectedDistrictKeys;
      } else {
        selectedDistrictKeys = newSelectedDistrictKeys;
        return table;
      }
    };

    return table;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'featureTable.html',
    scope: {
      layer: '=',
      selectedDistricts: '=',
      indicators: '=',
      config: '='
    },
    link: function (scope, element) {

      scope.config.fullscreen = scope.config.fullscreen || false;
      jQuery(element).find('.table-wrap').on('scroll', function(){
        jQuery(element).find('.table-overlay-wrap').find('table').css({'margin-left': -jQuery(this).scrollLeft()});
      });

      var featureTableFunction = featureTable();
      d3.select(element[0]).classed('feature-table', true);
      var rerender = function () {
        featureTableFunction
          .indicators(scope.indicators.filter(function(indicator) {
            return indicator.hasShapeData;
          }))
          .selectedDistrictKeys(scope.selectedDistricts.map(function(d) {
            return d.key;
          }));


        var elementSelection = d3.select(element.find('.widget-inner:first')[0]);
        elementSelection.selectAll('table')
          .datum(scope.layer)
          .call(featureTableFunction);
      };

      scope.fillExportFields = function () {
        // JSON for Table-Export
        scope.indicatorJson = angular.toJson(scope.indicators);
        scope.layerJson = angular.toJson(scope.layer);

        setTimeout(function(){
          scope.indicatorJson = scope.layerJson = '';
        }, 100);
      };

      jQuery(document).on("fullscreen", rerender);

      var layerWatcher = scope.$watch('layer', rerender, true);
      var indicatorWatcher = scope.$watchCollection('indicators', rerender);
      var selectedDistrictsWatcher = scope.$watchCollection('selectedDistricts', rerender);
      var fullscreenWatcher = scope.$watch('config.fullscreen', rerender);

      element.on('$destroy', function () {
        layerWatcher();
        indicatorWatcher();
        selectedDistrictsWatcher();
        fullscreenWatcher();
      });
    }
  };
});
